module.exports = __webpack_public_path__ + "img/17.2e4515b7.png";